import React from 'react';
import { Home } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { RouteConstant } from '../routes/RouteConstant';

const NotFound = () => {

    const navigate = useNavigate()

  const goHome = () => {
    navigate(RouteConstant.ROOT)
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100 flex flex-col items-center justify-center p-8">
      <div className="relative text-center space-y-8 max-w-lg">
        {/* Decorative background number */}
        <div className="absolute -top-32 left-1/2 -translate-x-1/2 text-gray-100 text-[20rem] font-bold select-none pointer-events-none">
          404
        </div>
        
        {/* Main content */}
        <div className="relative">
          {/* Main heading */}
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Page Not Found
          </h1>
          
          {/* Description */}
          <p className="text-gray-600 text-lg leading-relaxed">
            The page you're looking for doesn't exist or has been moved.
          </p>
        </div>

        {/* Action button */}
        <div className="relative pt-4">
          <button
            onClick={goHome}
            className="group inline-flex items-center justify-center px-8 py-3 bg-gray-900 text-white rounded-full hover:bg-gray-800 transition-all duration-200 ease-in-out hover:shadow-lg"
          >
            <Home className="w-5 h-5 mr-2 transition-transform group-hover:-translate-y-0.5" />
            <span className="transition-transform group-hover:-translate-y-0.5">
              Return Home
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;